import { ENEMY_Z_STAGGER, TEAMMATE_Z_STAGGER } from './constants';
import type { FormationSlot } from './types';

/** Lateral + depth slots so foes fan out and stack in Z. */
export function enemyFormationSlot(index: number, count: number, boundX: number): FormationSlot {
  const t = count <= 1 ? 0.5 : index / (count - 1);
  const x = (t - 0.5) * 2 * boundX * 0.7;
  // Alternate high/low so they don’t share a lane
  const yPattern = [0, 4.5, -4.5, 2.5];
  const y = yPattern[index % yPattern.length] ?? 0;
  // Depth: 0 is closest engage ring; higher index sits further ahead
  const engageExtra = index * ENEMY_Z_STAGGER;
  return { x, y, engageExtra };
}

/** Lateral + depth slots so friendlies fan out and stack slightly in Z. */
export function teammateFormationSlot(index: number, count: number, boundX: number): FormationSlot {
  const t = count <= 1 ? 0.5 : index / (count - 1);
  const x = (t - 0.5) * 2 * boundX * 0.55;
  const yPattern = [0, 3.5, -3.5];
  const y = yPattern[index % yPattern.length] ?? 0;
  const engageExtra = index * TEAMMATE_Z_STAGGER;
  return { x, y, engageExtra };
}
